import { Marker } from '@design-systems/canvas-ui'
import { LIFECYCLE_STATUS_BADGES } from '../config/lifecycleStatusConfig'
import './LifecycleStatusBadge.css'

// The brand_lifecycle_status marker, with the same label and colour wherever a
// brand's status is shown. A status without an entry reads as `fallbackLabel`.
const LifecycleStatusBadge = ({
  className = '',
  fallbackLabel = '',
  status,
}) => {
  const { color = 'grey', label = fallbackLabel } =
    LIFECYCLE_STATUS_BADGES[status] || {}

  return (
    <Marker
      aria-label={`Brand lifecycle status: ${label}`}
      className={`lifecycle-status-badge--${color} ${className}`}
      color={color}
    >
      {label}
    </Marker>
  )
}

export default LifecycleStatusBadge
